import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { MdOutlineLiveTv, MdOutlineNotStarted } from "react-icons/md";
import styles from "./Dashboard.module.scss";
import { getAllConfigs, toggleConfigEntry } from "../../utils/network/Crud";

const ManageLive = () => {
  const [showLive, setShowLive] = useState(false);
  const [channelId, setChannelId] = useState("");
  const [videoId, setVideoId] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const loadConfig = async () => {
    setLoading(true);
    const data = await getAllConfigs();
    const find = (id) => data?.data?.find((c) => c.id === id);
    setShowLive(!!find("showLive")?.showLive);
    setChannelId(find("channelId")?.channelId || "");
    setVideoId(find("liveVideoId")?.liveVideoId || "");
    setLoading(false);
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const handleToggle = async () => {
    setSaving(true);
    try {
      await toggleConfigEntry("showLive", !showLive);
      setShowLive(!showLive);
      toast.success(!showLive ? "Live stream is now visible" : "Live stream hidden");
    } catch (error) {
      toast.error("Failed to update");
    }
    setSaving(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await toggleConfigEntry("channelId", channelId);
      await toggleConfigEntry("liveVideoId", videoId);
      toast.success("Live stream settings saved");
    } catch (error) {
      toast.error("Failed to save settings");
    }
    setSaving(false);
  };

  return (
    <div>
      <div className={styles.pageHeader}>
        <div>
          <h2>Live Stream</h2>
          <p>Control the YouTube live darshan shown on the Home page.</p>
        </div>
      </div>

      <div className={styles.panel}>
        <div className={styles.toggleRow}>
          <div>
            <strong>Live Stream Visibility</strong>
            <span>Show or hide the live player on the public site</span>
          </div>
          <label className={styles.switch}>
            <input type="checkbox" checked={showLive} onChange={handleToggle} disabled={loading || saving} />
            <span className={styles.slider}></span>
          </label>
        </div>
      </div>

      <div className={styles.panel}>
        <h3 style={{ marginTop: 0, color: "#f0b23c", fontSize: 15 }}>
          <MdOutlineLiveTv style={{ verticalAlign: "middle", marginRight: 6 }} />
          Stream Source
        </h3>
        <div className={styles.formGrid}>
          <div className={styles.formGroup}>
            <label>YouTube Video ID (preferred — most reliable)</label>
            <input
              placeholder="e.g. dQw4w9WgXcQ (from youtube.com/watch?v=...)"
              value={videoId}
              onChange={(e) => setVideoId(e.target.value.trim())}
            />
          </div>
          <div className={styles.formGroup}>
            <label>YouTube Channel ID (fallback — auto live)</label>
            <input
              placeholder="e.g. UCxxxxxxxxxxxxxxxxxxxxxx"
              value={channelId}
              onChange={(e) => setChannelId(e.target.value.trim())}
            />
          </div>
          <button className={styles.primaryBtn} onClick={handleSave} disabled={saving} style={{ alignSelf: "flex-start" }}>
            <MdOutlineNotStarted /> {saving ? "Saving…" : "Save Stream Settings"}
          </button>
        </div>
        <p style={{ fontSize: 12, color: "#8b81a3", marginTop: 16, lineHeight: 1.6 }}>
          If a Video ID is set, it takes priority and plays that exact broadcast (live or recorded).
          Otherwise the Channel ID is used to auto-embed whatever is currently live on that channel.
        </p>
      </div>
    </div>
  );
};

export default ManageLive;
